/*
  AZM hover gallery — hover a product card and its main photo is pushed to the left
  by the product's next photo (slide). Move the mouse away and the photos slide back
  to the right, returning to the original main photo.
  Desktop / mouse only; skipped for reduced motion.

  Markup comes from snippets/card-product.liquid:
    <div class="card-wrapper" data-azm-gallery="url2|url3|url4"> … .card__media img … </div>
  The extra photos are only requested once someone hovers the card.
*/
(function () {
  if (window.azmHoverLoaded) return;
  window.azmHoverLoaded = true;

  var hoverOK = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DELAY = 120;   // ignore very quick fly-overs
  var SLIDE = 550;   // slide animation length (matches the CSS)

  var current = null;
  var state = null;

  // Build (or reuse) the sliding layer inside the card's picture box
  function layerFor(box, base, urls) {
    var existing = box.querySelector('.azm-hv');
    if (existing && existing._slide) {
      clearTimeout(existing._remove);
      return existing;
    }

    var first = base.currentSrc || base.src;
    var all = [first].concat(urls);
    var n = all.length;

    var layer = document.createElement('div');
    layer.className = 'azm-hv';
    layer.setAttribute('aria-hidden', 'true');

    var track = document.createElement('div');
    track.className = 'azm-hv__track';
    all.forEach(function (u) {
      var im = document.createElement('img');
      im.src = u;
      im.alt = '';
      im.draggable = false;
      track.appendChild(im);
    });

    var dots = document.createElement('div');
    dots.className = 'azm-hv__dots';
    for (var i = 0; i < n; i++) dots.appendChild(document.createElement('span'));

    layer.appendChild(track);
    layer.appendChild(dots);
    box.appendChild(layer);

    layer._slide = function (idx) {
      track.style.transform = idx ? 'translateX(-' + idx * 100 + '%)' : '';
      for (var k = 0; k < dots.children.length; k++) {
        dots.children[k].className = k === idx ? 'is-on' : '';
      }
    };
    layer._slide(0);
    // make sure the first frame is painted at position 0 before the push
    void track.offsetWidth;
    return layer;
  }

  function start(card) {
    if (!hoverOK.matches || reduce.matches) return;
    var urls = (card.getAttribute('data-azm-gallery') || '').split('|').filter(Boolean);
    var box = card.querySelector('.card__media');
    var base = box && box.querySelector('img');
    if (!urls.length || !base) return;

    current = card;
    var s = (state = { card: card, layer: null, loaded: false });

    // load the next photo; the push starts as soon as it is ready
    var next = new Image();
    var ready = function () { s.loaded = true; };
    next.onload = ready;
    next.onerror = ready;
    next.src = urls[0];
    // warm the remaining photos for the next time
    urls.slice(1).forEach(function (u) { new Image().src = u; });

    s.timer = setTimeout(function wait() {
      if (state !== s) return;
      if (!s.loaded) { s.timer = setTimeout(wait, 80); return; }
      s.layer = layerFor(box, base, urls);
      // a moment later so the browser animates from the first photo (timer, not rAF: rAF pauses in background tabs)
      setTimeout(function () {
        if (state !== s || !s.layer) return;
        s.layer._slide(1);
      }, 30);
    }, DELAY);
  }

  function stop() {
    var s = state;
    state = null;
    current = null;
    if (!s) return;
    clearTimeout(s.timer);
    var layer = s.layer;
    if (!layer) return;
    // slide back to the right, to the original main photo, then remove the layer
    layer._slide(0);
    layer._remove = setTimeout(function () {
      if (layer.parentNode) layer.parentNode.removeChild(layer);
    }, SLIDE + 80);
  }

  document.addEventListener('mouseover', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.card-wrapper[data-azm-gallery]') : null;
    if (card === current) return;
    stop();
    if (card) start(card);
  });

  document.documentElement.addEventListener('mouseleave', stop);
  document.addEventListener('visibilitychange', stop);
})();
